import { render, staticRenderFns } from "./CmgRetroCreditMessage.vue?vue&type=template&id=47b49bf2&scoped=true&lang=pug&"
import script from "./cmg-retro-credit-message.ts?vue&type=script&lang=ts&"
export * from "./cmg-retro-credit-message.ts?vue&type=script&lang=ts&"
import style0 from "./CmgRetroCreditMessage.vue?vue&type=style&index=0&id=47b49bf2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b49bf2",
  null
  
)

export default component.exports